import { Component, computed, inject } from '@angular/core';
import { RouteDaysComponent } from '../../../../shared/planner/shared/route-days/route-days.component';
import { MoreComponent } from './components/more/more.component';
import { ChatbotCustomRouteDesktopComponent } from "./components/chatbot-custom-route-desktop/chatbot-custom-route-desktop.component";
import { ChatBotScriptService } from 'src/app/services/chatbot.service';

@Component({
  selector: 'app-actions-footer-bar',
  standalone: true,
  imports: [
    RouteDaysComponent,
    MoreComponent,
    ChatbotCustomRouteDesktopComponent
],
  templateUrl: './actions-footer-bar.component.html',
  styleUrls: ['./actions-footer-bar.component.scss'],
})
export class ActionsFooterBarComponent {
  private _chatbotScriptService = inject(ChatBotScriptService);
  
  private readonly _chatId = computed(() => this._chatbotScriptService.chatId());
  get chatId() {
    return this._chatId();
  }

}
